import React from 'react';
import { IconProps } from '../types';
const MinecraftFireworkStarOverlay: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="3" width="1" height="1" fill="rgba(204, 204, 204, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(204, 204, 204, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(232, 232, 232, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(204, 204, 204, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(232, 232, 232, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(204, 204, 204, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(204, 204, 204, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(232, 232, 232, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(232, 232, 232, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(232, 232, 232, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(204, 204, 204, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(204, 204, 204, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(172, 172, 172, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(232, 232, 232, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(172, 172, 172, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(232, 232, 232, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(172, 172, 172, 255)" />
</svg>);
export default MinecraftFireworkStarOverlay;